import { useInView } from '../hooks/useInView';
import { SKILLS } from '../data';

function SkillBar({ skill, index, animate }) {
  return (
    <div className="flex items-center gap-3 px-3 py-2.5 bg-surf border border-bord rounded-xl">
      <span className="font-mono text-[11px] font-medium text-tx w-32 flex-shrink-0 truncate">{skill.name}</span>
      <span className="font-mono text-[9px] text-tx3 w-5 flex-shrink-0">{skill.years}y</span>
      <div className="flex-1 h-1.5 bg-bord rounded-full overflow-hidden">
        <div className="h-full rounded-full transition-none"
             style={{
               background: `linear-gradient(90deg,${skill.color},${skill.color}99)`,
               width: animate ? `${skill.pct}%` : '0%',
               transition: animate ? `width 1.25s ${index * 0.055}s cubic-bezier(.25,.46,.45,.94)` : 'none',
             }} />
      </div>
      <span className="font-mono text-[10px] w-8 text-right flex-shrink-0 tabular-nums" style={{ color: skill.color }}>
        {skill.pct}%
      </span>
    </div>
  );
}

export default function Skills() {
  const [ref, inView] = useInView(0.12);
  return (
    <section id="skills" className="relative z-10 py-24 px-5 sm:px-8 bg-bg">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <span className="section-tag bg-pg/[.12] border border-pg/22 text-pg">{`// SKILLS`}</span>
          <h2 className="font-display font-extrabold tracking-tight" style={{ fontSize: 'clamp(28px,4vw,46px)' }}>
            What I <span className="text-pg">work with</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* SQL terminal */}
          <div className="bg-bg2 border border-bord2 rounded-2xl overflow-hidden">
            <div className="flex items-center gap-1.5 px-4 py-3 border-b border-bord bg-surf">
              {['#EF4444','#F59E0B','#10B981'].map(c => (
                <div key={c} className="w-2.5 h-2.5 rounded-full opacity-85" style={{ background: c }} />
              ))}
              <span className="font-mono text-[10px] text-tx3 ml-2">psql@aws-rds:~/akrosh</span>
            </div>
            <div className="p-5 sm:p-6">
              {[
                [{ t:'SELECT ', kw:true },{ t:'skill, proficiency, years' }],
                [{ t:'FROM ',   kw:true },{ t:'developer_skills', tbl:true }],
                [{ t:'WHERE ',  kw:true },{ t:"developer = " },{ t:"'Akrosh R M'", str:true }],
                [{ t:'ORDER BY ',kw:true },{ t:'proficiency ' },{ t:'DESC', kw:true },{ t:';', cm:true }],
              ].map((line, i) => (
                <div key={i} className="font-mono text-xs leading-loose">
                  {line.map((p, j) => (
                    <span key={j} style={{ color: p.kw ? '#FF9900' : p.tbl ? '#4A90C4' : p.str ? '#10B981' : p.cm ? '#64748B' : '#94A3B8' }}>
                      {p.t}
                    </span>
                  ))}
                </div>
              ))}
              <div className="mt-4 pt-3 border-t border-bord font-mono text-[10px] text-grn">
                ✓ {SKILLS.length} rows returned in 2ms
              </div>
              <div className="mt-5 flex flex-col gap-2">
                {[
                  { range:'80–90%', label:'Production expert', color:'#FF9900' },
                  { range:'60–79%', label:'Daily driver',      color:'#10B981' },
                  { range:'30–59%', label:'Actively learning', color:'#8B5CF6' },
                ].map(item => (
                  <div key={item.range} className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: item.color }} />
                    <span className="font-mono text-[9px] text-tx3">{item.range} — {item.label}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Skill bars */}
          <div ref={ref} className="flex flex-col gap-2">
            {SKILLS.map((s, i) => <SkillBar key={s.name} skill={s} index={i} animate={inView} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
